import React from 'react';
import { ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Legend } from 'recharts';

const CadeDomainCompareRadar = (props) => {
    // Props contain an object having the form name, concernLevelT1 and concernLevelT2
    if (props.progressCompare.length == 0) {
        return null;
    }

    // Just using partner and clinician for now (all seems too cluttered)
    const domainCompareData = props.progressCompare.map((cdp) => {
        return {
            "subject": cdp.name,
            "A": cdp.concernLevelT1,
            "B": cdp.concernLevelT2,
            "fullMark": props.fullMark
        }

    });

    let nameT1 = props.t1Label;
    let strokeT1 = "lightblue";
    let fillT1 = "lightblue";

    let nameT2 = props.t2Label;
    let strokeT2 = "#4780BF";
    let fillT2 = "#4780BF";

    return (
        <ResponsiveContainer height={550}>
            <RadarChart outerRadius={props.outerRadius} data={domainCompareData} >
                <PolarGrid />
                <PolarAngleAxis dataKey="subject" />
                <PolarRadiusAxis tick={false} axisLine={false} angle={30} fullMark={props.fullMark} domain={[0, props.fullMark]} />
                <Radar name={nameT1} dataKey={"A"} stroke={strokeT1} fill={fillT1} fillOpacity={0.6} />
                <Radar name={nameT2} dataKey={"B"} stroke={strokeT2} fill={fillT2} fillOpacity={0.6} />
                <Legend />
            </RadarChart>
        </ResponsiveContainer>
    );
}

export default CadeDomainCompareRadar;

//const data = [
//    { subject: 'Communicating', A: 3, B: 2, fullMark: 3 },
//    { subject: 'Learning', A: 2, B: 1, fullMark: 3 },
//    { subject: 'Behaving', A: 1, B: 1, fullMark: 3 },
//    { subject: 'Sensing', A: 2, B: 0, fullMark: 3 }
//];

//const TwoLevelPieChart = React.createClass({
//    render() {
//        return (
//            <RadarChart cx={300} cy={250} outerRadius={150} width={600} height={500} data={data}>
//                <PolarGrid />
//                <PolarAngleAxis dataKey="subject" />

//                <Radar name="Nov 2019" dataKey="A" stroke="lightblue" fill="lightblue" fillOpacity={0.6} />
//                <Radar name="Jan 2020" dataKey="B" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6} />
//                <Legend />

//            </RadarChart>
//        );
//    }
//})


// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadeDomainCompareRadar.js